class BlogArticle extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['heading']
  }

  connectedCallback () {
    super.connectedCallback()
    this.setupIntersectionObserver()
  }

  setupIntersectionObserver () {
    const stickyTop = parseInt(
      window.getComputedStyle(this.els.heading.element).top,
    )
    const currentTop = this.els.heading.element.getBoundingClientRect().top

    this.els.heading.element.classList.toggle(
      'art-Detail_HeadingSticky',
      currentTop === stickyTop,
    )
  }

  setupListeners () {
    this.setupIntersectionObserver = this.setupIntersectionObserver.bind(this)

    window.addEventListener('scroll', this.setupIntersectionObserver, {
      passive: true,
    })
  }
}

if (!customElements.get('blog-article')) {
  customElements.define('blog-article', BlogArticle)
}
